module.exports = __webpack_public_path__ + "static/media/bettermaker_bg_x.a4678ced.png";